<div class="grid dashboard">
  @if (isLoading === true) {
    <div #divpdf>
      @if (pathPdf) {
        <div class="max-pdf-nat">
            <pdf-preview style="position:relative" [pathPdf]="pathPdf"></pdf-preview>
        </div>
      }
    </div>
  } @else {
    <app-loader [message]="loadingMessage"></app-loader>
  }
</div>

